import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { fetchRawReferrals } from "../../services/rawReferrals";
import { STATUS } from "../../constants";
import { useDispatch } from "react-redux";
import { useEffect } from "react";
import firebase, { FS } from "../../services/firebase";

export const getRawReferralsAI = createAsyncThunk("rawReferrals/fetchRawReferralsAI", async (source) => {
  const response = await fetchRawReferrals(source);
  return response.data;
});

export const useRealtimeReferrals = (source) => {
  const dispatch = useDispatch();
  useEffect(() => {
    if (source !== "ai_extracted_referrals") {
      return;
    }

    dispatch(rawReferralsAISlice.actions.setLoading());
    const unsubscribe = FS.onSnapshot(
      FS.query(FS.collection(firebase.modularFirestore(), source)),
      (snapshot) => {
        const referrals = snapshot.docs.map((doc) => ({
          id: doc.id,
          ...doc.data(),
        }));
        dispatch(rawReferralsAISlice.actions.setData(referrals));
      },
      (error) => {
        console.error("Error fetching real-time referrals:", error);
        dispatch(rawReferralsAISlice.actions.setError());
      }
    );
    return () => unsubscribe();
  }, [source, dispatch]);
};

const rawReferralsAISlice = createSlice({
  name: "raw_referrals_ai",
  initialState: { data: [], status: STATUS.DEFAULT },
  reducers: {
    setData: (state, action) => {
      state.data = action.payload;
      state.status = STATUS.SUCCEED;
    },
    setError: (state) => {
      state.status = STATUS.FAILED;
    },
    setLoading: (state) => {
      state.status = STATUS.LOADING;
    },
  },
  extraReducers: {},
});

export default rawReferralsAISlice;
